﻿import {translation} from "@2d-front-monorepo/core";
import {showErrorDialog, toggleLoadingDialog} from "@2d-front-monorepo/design-library";
import {AttachmentResult, PermitResult, PermitStatusType} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX, useCallback} from "react";
import {useNavigate} from "react-router";
import {getHttpClient} from "../../../hooks/getHttpClient";
import {ReloadEntities, reloadPermits} from "../../../hooks/reloadPermits";
import {PrivateRoutes} from "../../../routes";

export function SentToReviewComponent({permit, expired}: { permit: PermitResult, expired: AttachmentResult[] }): JSX.Element | undefined {
	const canSubmitForReview = permit.status.type === PermitStatusType.RequestMoreInformation && expired.length === 0;

	const navigate = useNavigate();

	const onSubmit = useCallback(async function (): Promise<void> {
		toggleLoadingDialog(true);
		try {
			await getHttpClient().permits.submitForReview(permit.id);

		} catch (error) {
			// Stay on the permit: navigating away on failure made the submit look successful
			// while the permit silently remained in RequestMoreInformation.
			showErrorDialog(error);
			return;

		} finally {
			toggleLoadingDialog(false);
		}

		await reloadPermits(ReloadEntities.Permits);
		navigate(PrivateRoutes.permitsList);
	}, [permit.id, navigate]);

	if (!canSubmitForReview) {
		return undefined;
	}

	return (
		<div className={"padded inline"}>
			<dl className={"title-desc entity-documentation-list--expired"}>
				<dt>{translation(PermitTranslations.documentation__expired)}</dt>
				<dd>
					<ol className="entity-documentation-list">
						<li>{translation(PermitTranslations.documentation__updated)}</li>
					</ol>
					<button className="entity-documentation-update form__button form__button--primary form__button--small"
					        onClick={onSubmit}>
						{translation(PermitTranslations.send_for_review)}
					</button>
				</dd>
			</dl>
		</div>
	);
}
